(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logos-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = new Map();

    function initialize(root) {
      root.querySelectorAll('[data-logo-carousel]').forEach((carousel) => {
        if (carousels.has(carousel)) return;

        function synchronize() {
          const cells = Array.from(carousel.querySelectorAll('.logo-list__item'));
          const hidden = (cell) => cell.getAttribute('aria-hidden') === 'true';
          const focusedCell = cells.find((cell) => cell.contains(document.activeElement));

          cells.filter((cell) => !hidden(cell)).forEach((cell) => cell.removeAttribute('inert'));

          if (focusedCell && hidden(focusedCell)) {
            const visibleLink = cells.filter((cell) => !hidden(cell))
              .map((cell) => cell.querySelector('a[href]')).find(Boolean);
            (visibleLink || carousel).focus({ preventScroll: true });
          }

          cells.forEach((cell) => cell.toggleAttribute('inert', hidden(cell)));
        }

        const observer = new MutationObserver(synchronize);
        observer.observe(carousel, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
          childList: true,
          subtree: true
        });
        carousels.set(carousel, observer);
        synchronize();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      carousels.forEach((observer, carousel) => {
        if (!event.target.contains(carousel)) return;
        observer.disconnect();
        carousel.querySelectorAll('.logo-list__item[inert]').forEach((cell) => cell.removeAttribute('inert'));
        carousels.delete(carousel);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
